<template>
  <!--状态弹出框-->
  <el-dialog
    :visible.sync="changeHistoryVisible"
    title="Status"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthChangeHistory"
  >
    <div>
      <el-row style="margin-top: 15px;margin-left: 10%;margin-bottom: 20px">
        <el-col :span="20">
          <el-form-item label="Order Status:">
            <el-select class="length_input" value-key="key" placeholder="Please select"
                       size="mini" v-model="ebOrder.status">
              <el-option
                v-for="item in orderStatusList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="Date：" prop="etd">
            <el-date-picker
              v-model="ebOrder.date"
              style="width:100%;"
              align="right"
              type="date"
              size="mini"
              placeholder="Select a date"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 15px;margin-left: 25%;margin-bottom: 20px">
        <el-button type="primary" size="small" plain @click="saveOrderStatus">Save</el-button>
        <el-button type="primary" size="small" plain @click="cancelBox">Cancel</el-button>
      </el-row>

    </div>
  </el-dialog>
</template>

<script>

import {
  queryDictRows,
} from "@/api/commonService";
import { batchUpdateOrderStatus } from "@/api/bookingRequest";

export default {
  name: 'StatusBox',
  props: {
    changeHistoryVisibleFlagInit: Boolean,
    ebOrder: Object
  },
  data() {
    return {
      ebOrder: {
        status: null,
        data: null,
      },
      orderStatusList: [],
      changeHistoryVisible: false,
    }
  },
  // 监听
  watch: {
    changeHistoryVisibleFlagInit() {
      let self = this
      self.changeHistoryVisible = true
      this.queryChangeHistory()
    }
  },
  async created() {

  },
  mounted() {
    let self = this;
    self.queryEbOrderStatus();
    let _this = this;
  },
  methods: {
    //保存信息，修改对应状态
    saveOrderStatus() {
      let self = this;
      let flag = true;
      if (self.status !== undefined && self.ebOrder.date !== null ) {
        batchUpdateOrderStatus(self.ebOrder).then((res) => {
          if (res.success) {
            self.$coreMethods.message("success", this.$t('message.saveSuccessful'));
            self.queryStatusPage();
          } else {
            self.$coreMethods.message("error", this.$t('message.saveFailed'));
          }
        });
      } else {
        self.$coreMethods.message("error", this.$t('message.pleaseSelectData'));
        return;
      }
    },
//关闭弹窗
    cancelBox() {
      this.changeHistoryVisible = !this.changeHistoryVisible;
    },
//获取订单状态数据字典
    queryEbOrderStatus() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EB_ORDER_STATUS").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EB_ORDER_STATUS.forEach((item) => {
          let param = {};
          param.value = item.value;
          param.key = item.key;
          param.count = 0;
          dict.push(param);
        });
        self.orderStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({ EB_ORDER_STATUS: dict });
      });
    },
//子组件
    clickModule() {
    }
  }
}
</script>

<style>
.customWidthChangeHistory {
  width: 25%;
  height: 280px;
}

/* .el-dialog__header {
  background: deepskyblue;
}
 */
.el-dialog__body {
  padding: 0px;
}

</style>
